import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';

function PurchaseTable() {
  return (
    <div className='tableContainer'>
      <Table>
        <Thead>
          <Tr>
            <Th>Date</Th>
            <Th>FORFAIT</Th>
            <Th>MINUTES</Th>
            <Th>TYPE</Th>
            <Th>MONTANTS</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td className="color-red">13/03/2023</Td>
            <Td>00000000</Td>
            <Td>45:00</Td>
            <Td className="color-green">Text</Td>
            <Td className="color-purple">Text</Td>
          </Tr>
          <Tr>
            <Td className="color-red">13/03/2023</Td>
            <Td>00000000</Td>
            <Td>45:00</Td>
            <Td className="color-green">Text</Td>
            <Td className="color-purple">Text</Td>
          </Tr>
        </Tbody>
      </Table>
    </div>
  );
}

export default PurchaseTable;